<div *ngIf="show" class="spinner">
    <img src="assets/images/loading-01.gif">
</div>